export default "__VITE_ASSET__D93kY5gL__"